import * as ClassActions from './ClassActions.js';

const initialState = {
  classSessionEnrollments: [],
  classSessionsById: {},
  classSessionEnrollment: {},
};

export default function appointment(state = initialState, action) {
  switch (action.type) {
    case 'UNAUTHORIZED':
      return {
        ...initialState,
      };
    case 'LOGOUT':
      return {
        ...initialState,
      };
    case ClassActions.CLEAR_CLASS_SESSIONS:
      return {
        ...initialState,
      };
    case ClassActions.LOAD_CLASS_SESSIONS:
      return {
        ...state,
        classSessionEnrollments: [...action.data.classSessionEnrollments],
        classSessionsById: {...action.data.classSessionsById}
      };
    case ClassActions.SET_CLASS_SESSION_ENROLLMENT:
      return {
        ...state,
        classSessionEnrollment: action.data
      };
    default:
      return state;
  }
}
